import {FeatureLayerProperties, GRAPHIC_ATTRS, GRAPHIC_ATTR_IDS} from "../../models";
import {OBJECTID} from "../map";
import {MapLayerColor, MapTool} from "../../enums";
import {DibujoType} from "../../../../chacra-core/models";

export const PENDIENTES_LAYER: FeatureLayerProperties = {
  name: 'pendiente',
  title: 'Pendiente',
  objectIdField: OBJECTID,
  geometryType: DibujoType.POLYLINE,
  spatialReference: {wkid: 4326},
  outFields: ['chacraId'],
  opacity: 1,
  fields: [
    {name: 'graphicAttr', alias: 'Graphic Attr Type', type: 'string'},
    {name: 'featureName', alias: 'Feature Name', type: 'string'},
    {name: 'chacraId', alias: 'Chacra Id', type: 'string'},
    {
      name: 'chacraFactorLSEsManual',
      alias: 'Manual',
      type: 'string'
    }
  ],
  renderer: {
    type: 'simple',
    symbol: {
      type: 'simple-line',
      color: MapLayerColor.pendiente,
      width: '1px',
      style: 'short-dot'
    }
  },
  graphicAttr: GRAPHIC_ATTRS.CHACRA_FACTOR_LS_ASIGNADO,
  attrId: GRAPHIC_ATTR_IDS.CHACRA,
  exportable: true,
  tools: [MapTool.polyline]
};
